class e extends Error {
  constructor(o) {
    super(o), this.location = o;
  }
}
export {
  e as UnauthorizedResponse
};
